import { render, staticRenderFns } from "./AddMenuGroupCatalog.vue?vue&type=template&id=9436bc0a&scoped=true"
import script from "./AddMenuGroupCatalog.vue?vue&type=script&lang=js"
export * from "./AddMenuGroupCatalog.vue?vue&type=script&lang=js"
import style0 from "./AddMenuGroupCatalog.vue?vue&type=style&index=0&id=9436bc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9436bc0a",
  null
  
)

export default component.exports